import { combineReducers } from '@reduxjs/toolkit'
import player from './playerSlice'

const reducer = combineReducers({
  player,
})

export default reducer
